/**
 * Deduction API
 * 일차감 관련 API 호출 함수
 */

import { apiClient } from '../../../core/api/client';
import {
    DeductionRequest,
    DeductionResponse,
    DeductTypeCodeResponse,
    DeductionDetailRequest,
    DeductionDetailResponse,
} from '../types/deduction';

const BASE_PATH = '/api/v1/mob/deduct';

/**
 * 라이더용 일차감 데이터 조회 API
 * @param startDay 시작일 (YYYY-MM-DD)
 * @param endDay 종료일 (YYYY-MM-DD)
 * @returns 일차감 데이터 응답
 */
export const getDeductionData = async (startDay?: string, endDay?: string): Promise<DeductionResponse> => {
    const response = await apiClient.get<DeductionResponse>(
        `${BASE_PATH}/rider-deduct-daily-list`,
        { params: { startDay, endDay } }
    );
    return response.data;
};

/**
 * 협력사용 일차감 데이터 조회 API (소속 모든 라이더)
 * @param startDay 시작일 (YYYY-MM-DD)
 * @param endDay 종료일 (YYYY-MM-DD)
 * @returns 일차감 데이터 응답
 */
export const getSupplierDeductionData = async (startDay?: string, endDay?: string): Promise<DeductionResponse> => {
    const response = await apiClient.get<DeductionResponse>(
        `${BASE_PATH}/supplier-deduct-daily-list`,
        { params: { startDay, endDay } }
    );
    return response.data;
};

/**
 * 공제 타입 코드 조회 API
 * @returns 공제 타입 코드 목록
 */
export const getDeductTypeCodes = async (): Promise<DeductTypeCodeResponse> => {
    const response = await apiClient.get<DeductTypeCodeResponse>(
        `${BASE_PATH}/deduct-type-codes`
    );
    return response.data;
};

/**
 * 일차감 상세 조회 API
 * @param params 일차감 상세 요청 파라미터
 * @returns 일차감 상세 응답
 */
export const getDeductionDetail = async (
    params: DeductionDetailRequest
): Promise<DeductionDetailResponse> => {
    const response = await apiClient.get<DeductionDetailResponse>(
        `${BASE_PATH}/deduct-detail`,
        { params }
    );
    return response.data;
};
